import ScrollReveal from "@/components/base/ScrollReveal";

export default function CredibilitySection() {
  const stats = [
    {
      number: "37",
      label: "Years of Experience",
    },
    {
      number: "5",
      label: "Core Advisory Service Pillars",
    },
    {
      number: "Enterprise",
      label: "Public Sector (Government) & Private Sector",
    },
  ];

  return (
    <section className="relative bg-bg py-14 md:py-18 overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <ScrollReveal>
            <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-12">
              {stats.map((s, i) => (
                <div key={i} className="flex items-center gap-4 md:gap-5">
                  <span className="font-serif text-[36px] md:text-[44px] font-semibold text-primary whitespace-nowrap">
                    {s.number}
                  </span>
                  <span className="font-sans text-[14px] md:text-[15px] text-text-muted leading-snug max-w-[160px]">
                    {s.label}
                  </span>
                  {i < stats.length - 1 && (
                    <div className="hidden md:block w-px h-12 bg-border ml-4" />
                  )}
                </div>
              ))}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}